const env = process.env.NODE_ENV
var url = 'https://train.aojuai.com/ajtools';
// var url = 'http://192.168.11.103:19091/ajtools'; 
// var url = 'https://train.aojuai.com';
// 新服务
const config = {
  development:{
    // baseURL :url//本地
    baseURL :url, //线上 
   
  },
  production:{
     baseURL :'https://train.aojuai.com/ajtools',

  }
}
export default {  
  baseURL:config[env].baseURL,
}